import React from 'react';
import startGold from "../assets/images/startGold.png";
import startWhite from "../assets/images/startWhite.png";

const StarRating = ({ rating, maxRating = 5 }) => {
    const stars = Array.from({ length: maxRating }, (_, index) => (
        <img
            key={index}
            src={index < rating ? startGold : startWhite}
            alt="star"
            className="me-1" width={20} height={20}
        />
    ));

    return <div className="d-flex justify-content-between w-100">{stars}</div>;
};

export default StarRating;